import {Component} from 'panel';

import {registerMPElement} from 'common/util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

const DISPLAY_TYPE = {
  DEFAULT: `default`,
  ERROR: `error`,
  SENSITIVE: `sensitive`,
};

export default class EmptyReportHero extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'header-text': `string`,
      'body-text': `string`,
      'cta-href': `string`,
      'cta-text': `string`,
      type: {type: `string`, default: DISPLAY_TYPE.DEFAULT, enum: Object.values(DISPLAY_TYPE)},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleCtaClick: () => this.dispatchEvent(new CustomEvent(`ctaClick`)),
      },
    };
  }
}

registerMPElement(`mp-empty-report-hero`, EmptyReportHero);
